'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/shad';
import { POWER_BAR_MARKER_LINE_WIDTH, POWER_BAR_TICK_COLOR, POWER_BAR_TICK_COLOR_LIT, STANDARD_POWER_BAR_LAYOUT, type PowerBarLayout } from '@/domains/pages/shared/power-bar-shared';
type PowerBarMarkerProps = {
  position: string;
  layout?: PowerBarLayout;
  lit?: boolean;
  color?: string;
  litColor?: string;
  ariaLabel: string;
  className?: string;
  tabIndex?: number;
  onMouseEnter: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

/** Vertical benchmark tick — centered on the track via shared layout metrics. */
export function PowerBarMarker(t0) {
  const $ = _c(17);
  const {
    position,
    layout: t1,
    lit: t2,
    color: t3,
    litColor: t4,
    ariaLabel,
    className,
    tabIndex: t5,
    onMouseEnter,
    onFocus,
    onBlur
  } = t0;
  const layout = t1 === undefined ? STANDARD_POWER_BAR_LAYOUT : t1;
  const lit = t2 === undefined ? false : t2;
  const color = t3 === undefined ? POWER_BAR_TICK_COLOR : t3;
  const litColor = t4 === undefined ? POWER_BAR_TICK_COLOR_LIT : t4;
  const tabIndex = t5 === undefined ? -1 : t5;
  let t6;
  if ($[0] !== className) {
    t6 = cn("absolute z-10 flex w-5 -translate-x-1/2 cursor-pointer items-center justify-center bg-transparent p-0", className);
    $[0] = className;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const t7 = `${layout.markerHeightPx}px`;
  let t8;
  if ($[2] !== position || $[3] !== t7) {
    t8 = {
      left: position,
      top: 0,
      height: t7
    };
    $[2] = position;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = `${layout.markerHeightPx}px`;
  const t10 = lit ? litColor : color;
  let t11;
  if ($[5] !== t10 || $[6] !== t9) {
    t11 = <span className="block rounded-full transition-colors duration-150" style={{
      width: POWER_BAR_MARKER_LINE_WIDTH,
      height: t9,
      backgroundColor: t10
    }} />;
    $[5] = t10;
    $[6] = t9;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== ariaLabel || $[9] !== onBlur || $[10] !== onFocus || $[11] !== onMouseEnter || $[12] !== t11 || $[13] !== t6 || $[14] !== t8 || $[15] !== tabIndex) {
    t12 = <button type="button" tabIndex={tabIndex} aria-label={ariaLabel} className={t6} style={t8} onMouseEnter={onMouseEnter} onFocus={onFocus} onBlur={onBlur}>{t11}</button>;
    $[8] = ariaLabel;
    $[9] = onBlur;
    $[10] = onFocus;
    $[11] = onMouseEnter;
    $[12] = t11;
    $[13] = t6;
    $[14] = t8;
    $[15] = tabIndex;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  return t12;
}